// cartmaker.ts

import axios from 'axios';

interface CartProduct {
  username: string;
  password: string;
  items: Array<{
    code: string;
    quantity: string;
  }>;
}

/**
 * Makes an API request to localhost:8080/cart, sending the items as JSON.
 * @param data Array of products to add.
 * @returns Response data from the local server.
 */
export async function addProductsToCart(data: CartProduct): Promise<any> {
  try {
    const response = await fetch('http://localhost:8000/add-to-cart', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      body: JSON.stringify({
        products: data
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to add items to cart: ${response.statusText}`);
    }

    const result = await response.json();
    console.log('Add to Cart Response:', result);
    
    if (result.status === 'success' && result.checkout_url) {
      window.open(result.checkout_url, '_blank');
    } else {
      console.error('Failed to retrieve checkout URL');
    }

    return result;
  } catch (error: any) {
    console.error("Error posting products to local server:", error.message);
    throw error;
  }
}
